import {defineStore} from 'pinia'
import {Ref, ref} from "vue";
import axios from "axios";
import {AxiosListResponse} from "@/types/response";
import {PageGroup} from "@/types/dto";


export const pageStore = defineStore("pageStore", () => {

    const isInit = ref(false);

    async function queryPage() {
        const res: AxiosListResponse<PageGroup> = await axios.get("pc/login/page")
        if (res.data.code == 0) {
            isInit.value = true;
            return res.data.data
        } else {
            throw "页面信息加载失败,请刷新页面重试";
        }
    }

    return {
        queryPage,isInit
    }
})